"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavGroup = exports.NavWrapper = exports.Nav = void 0;

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _NavItem = require("./NavItem");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Nav = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ex9z48e2"
} : {
  target: "ex9z48e2",
  label: "Nav"
})(process.env.NODE_ENV === "production" ? {
  name: "1jqf4gi",
  styles: "height:3rem;position:relative;text-align:center;z-index:3"
} : {
  name: "1jqf4gi",
  styles: "height:3rem;position:relative;text-align:center;z-index:3",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.Nav = Nav;
var NavWrapper = /*#__PURE__*/(0, _theming.styled)("nav", process.env.NODE_ENV === "production" ? {
  target: "ex9z48e1"
} : {
  target: "ex9z48e1",
  label: "NavWrapper"
})(_styles.pageMargins, " padding-top:12px;@media (min-width: ", _styles.breakpoint, "px){padding-top:36px;}");
exports.NavWrapper = NavWrapper;

var _ref = process.env.NODE_ENV === "production" ? {
  name: "jr388m",
  styles: "left:auto;right:0"
} : {
  name: "csafef-NavGroup",
  styles: "left:auto;right:0;label:NavGroup;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var NavGroup = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ex9z48e0"
} : {
  target: "ex9z48e0",
  label: "NavGroup"
})("position:absolute;top:0;left:0;z-index:1;display:flex;", function (props) {
  return props.withRightAlignment && _ref;
}, "@media (min-width: ", function (props) {
  return props.navBreakpoint;
}, "px){", _NavItem.StyledNavItem, "+", _NavItem.StyledNavItem, "{margin-left:25px;}}");
exports.NavGroup = NavGroup;
NavGroup.defaultProps = {
  withRightAlignment: false
};